import React from "react";
import { TableCell } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { IPlayerCell } from "./types";
import { hexToString } from "utils";

interface IPassTableCellProps {
  rowPlayer: IPlayerCell;
  colPlayer: IPlayerCell;
  matrix: any;
  max: number;
}

const getBackgroundColor = (value: number, max: number): string => {
  const basicColor = "#94B447";
  const ff = 255;
  return basicColor + hexToString(Math.round((ff * value) / max));
};

const useStyles = makeStyles(() => ({
  tableCell: {
    background: (props: IPassTableCellProps) => {
      const { rowPlayer, colPlayer, matrix, max } = props;

      if (rowPlayer.id === colPlayer.id) {
        return getBackgroundColor(0, max);
      }

      const playerCell = matrix[rowPlayer.id].find((player: any) => {
        return player.toPlayer.toString() === colPlayer.id;
      });

      if (!playerCell) {
        return getBackgroundColor(0, max);
      }

      return getBackgroundColor(playerCell.succ, max);
    },
  },
}));

export const PassTableCell = (props: IPassTableCellProps) => {
  const classes = useStyles(props);
  const { rowPlayer, colPlayer, matrix } = props;

  const renderMatrixCell = () => {
    if (rowPlayer.id === colPlayer.id) {
      return "-";
    }

    const playerCell = matrix[rowPlayer.id].find((player: any) => {
      return player.toPlayer.toString() === colPlayer.id;
    });

    if (!playerCell) {
      return "0";
    }

    return `${playerCell.succ} / ${playerCell.total} (${(
      (playerCell.succ / playerCell.total) *
      100
    ).toFixed(1)}%)`;
  };

  return (
    <TableCell align="center" className={classes.tableCell}>
      {renderMatrixCell()}
    </TableCell>
  );
};
